import axios from 'axios';

export const orderService = {
    listOrders,
	listProjectHeaders,
	getOrder,
	listLanguagePairs,
	finishOrderTask,
	qaOrderTask,
	getTmxMatch,
	customerConfig,
	uploadProject,
	createProject,
	runProjectWF,
	updateOrderForm,
	updateTmxMatch,
	sendOdoo,
	uploadDocument,
	deleteOrder,
	unlockOrder,
	deleteProject,
	sendMessage,
	updateNonconformity,
	createNonconformity,
	WF_retranslate,
//	WF_reinterpretar,
//	WF_setState,
	WF_preprocesar,
	mergeProject,
	getRatingFromOrder,
	setRatingFromOrder,
	setRating,
	setState,
	finishRevisionTask
};

function listOrders(page, pageSize, filter) {
	let p  = (typeof page!= 'undefined' && page>0) ? page : 0;
	let ps = (typeof pageSize!= 'undefined' && pageSize>0) ? pageSize : 25;
	let f = "";
	let fp = 0;
	let fo = 0;
	let fr = 0;
	if(typeof filter!= 'undefined'){
		f = ( (typeof filter.searchString!=='undefined') && filter.searchString.length>1) ? new String(filter.searchString) : new String("");
		fp = ( (typeof filter.filterPending!=='undefined') && filter.filterPending>0) ? 1 : 0;
		fo = ( (typeof filter.filterOdoo!=='undefined') && filter.filterOdoo>0) ? 1 : 0;
		fr = ( (typeof filter.filterRating!=='undefined') && filter.filterRating>0) ? 1 : 0;
	}

//	console.log("filter:"+p+","+ps+",["+f+"]");
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/", {params: { queryMap: JSON.stringify({'page':p, 'pageSize': ps, 'filter': f, 'pendingOrders': fp, 'pendingOdoo': fo, 'ratings': fr})}});
	//return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/", {params: {}});
}


function listProjectHeaders(projects){
	let projectList = (typeof projects!= 'undefined' && projects!=null && projects.length>0)? projects.toString() : [].toString();//new String(JSON.stringify(projects))
//	console.log("projectList: "+projectList);
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/project/headers/", {params: { pList: projectList }});
}

function getOrder(orderId){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId, {params: {}});
}

function finishOrderTask(orderId, esxliff){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	const body = {'esxliff': esxliff}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/finish-task/", body, headers);
}

function finishRevisionTask(orderId, esxliff){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	const body = {'esxliff': esxliff}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/revision-task/", body, headers);
}

function WF_retranslate(orderId){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/re-open-task/", null, headers);
}

function mergeProject(projectId){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+projectId+"/merge-mlt/", null, headers);
}

function qaOrderTask(orderId, task, oauthToken, qaOK){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = {'format_OK': qaOK}
//	console.log("body: "+JSON.stringify(body));
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/qa/", body, headers);
}

function getTmxMatch(orderId) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/tmxmatch/", {params: {}});
}

function listLanguagePairs(oauthToken) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/lang/", {params: {}});
}

function customerConfig(cutomerId, oauthToken) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+cutomerId+"/", {params: {}});
}

function uploadProject(quotation, project, mlt){
	//console.log("uploadProject: "+JSON.stringify(project));

	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	const formData = new FormData();
	
	var projectArray = [];
	let index=0;
	project.forEach((srcDoc) => {
		if(srcDoc.enabled){
//			console.log("create Orders for["+srcDoc.id+"]: "+srcDoc.doc.name);
//			console.log("Amb help file["+srcDoc.id+"]: "+srcDoc.attachment.name);
			formData.append('srcFile[]', new File([srcDoc.doc], srcDoc.doc.name, { type: srcDoc.doc.type }));
			formData.append('helpFile[]', new File([srcDoc.attachment], srcDoc.attachment.name, { type: srcDoc.attachment.type }));
			srcDoc.product.forEach((task) => {
//				console.log("create Orders with task: "+task);
				var order = new Object();
				order.comment = srcDoc.comment;
				order.reference  = srcDoc.reference;
				order.task = task;
				order.urgent = (srcDoc.urgent)?1:0;
				order.special = (srcDoc.special)?1:0;
				order.quotation = (quotation)?1:0;
				order.srcFile = index;
				order.helpFile = index;
				projectArray.push(order);
			});
			index++;
		}
	});
	
	formData.append('data', JSON.stringify(projectArray));
	formData.append('mlt', mlt);
//	console.log("Sending: ");
//	console.log(projectArray);
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/project/", formData, headers);
}

function runProjectWF(oauthToken, projectId){
//	console.log("runProjectWF: "+projectId);

	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+projectId+"/run/", null, {params: {}});
}

function createProject(oauthToken) {
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/project/", null,{params: {}});
}

function sendOdoo(orderId, oauthToken){
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/invoice-odoo/", null, {params: {}});
}

function createOrder(oauthToken, idProject, comment, reference, doc,  task, language) {
	var obj = new Object();
	obj.comment = comment;
	obj.reference  = reference;
	obj.task = task;
	obj.langPair = language;
	
	var jsonString= JSON.stringify(obj);
	const formData = new FormData();
	formData.append('srcFile',doc);
	formData.append('data',jsonString);
	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+idProject+"/", formData, headers);
}

function deleteOrder(orderId, oauthToken) {
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.delete(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/", headers);
}

function unlockOrder(orderId) {
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/unlock", {}, headers);
}

function deleteProject(projectId) {
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.delete(process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+projectId+"/", headers);
}
//-------------------------------------------------------------------------
// OJU AMB ELS PUTS!!
//-------------------------------------------------------------------------
//	Cal:	- Enviar 'content-type': 'application/x-www-form-urlencoded'
//			- formData.set('_method', 'PUT')
//			- utilitzar axios.post(...)
//-------------------------------------------------------------------------

function updateOrderForm(order) {
//	console.log("updateOrderInfo: "+JSON.stringify(order));
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+order.id+"/", order, headers);
}

function updateTmxMatch(orderId, tmxMatch) {
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/tmxmatch/", tmxMatch, headers);
}

function uploadDocument(oauthToken, docHref, doc){
//	console.log("docHref: "+docHref);
	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	const formData = new FormData();
	formData.append('document', new File([doc], doc.name, { type: doc.type }));
	return axios.put(docHref+"/content/", formData, headers);
}

function sendMessage(orderId, message){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = {'message': message}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/chat/"+orderId, body, headers);
}

function setNonconformity(orderId, nonconformity){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = {'nonconformity': nonconformity}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/chat/"+orderId, body, headers);
}

function updateNonconformity(nonconformity){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/nonconformity/"+nonconformity.id, nonconformity, headers);
}

function createNonconformity(orderId, nonconformity){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/nonconformity/"+orderId, nonconformity, headers);
}

function getRatingFromOrder(id){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/rating/order/"+id+"/", {params: {}});
}

function setRatingFromOrder(id){
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/rating/order/"+id+"/", null, {params: {}});
}

function setRating(id, rating){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/rating/"+id, JSON.stringify(rating), headers);
}

function setState(id, state){
	let data = {'state': state};
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+id+"/set-state2", JSON.stringify(data), headers);
}

////(value = "/{id}/text-extraction", method = RequestMethod.POST)
//function WF_reinterpretar(orderId){
//	let headers = {
//		headers: {
//		  'Content-Type': 'application/json;charset=UTF-8'
//		},
//		params: {
//		}
//	}
//	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/text-extraction", null, headers);
//}

//(value = "/{id}/preprocess", method = RequestMethod.POST)
function WF_preprocesar(orderId, configuration){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/preprocess", configuration, headers);
}

////(value = "/{id}/set-state", method = RequestMethod.POST)
//function WF_setState(orderId, state){
//	let headers = {
//		headers: {
//		  'Content-Type': 'application/json;charset=UTF-8'
//		},
//		params: {
//		}
//	}
//	let body = {'state': state}
//	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/orders/"+orderId+"/set-state", body, headers);
//}